/* eslint-disable no-lone-blocks */
import axios, { AxiosRequestConfig } from 'axios';
import { paths } from './ServiceConstants';
import { Constants, STORAGE_KEY } from '../utils/Constant';
import DebugUtils from '../utils/DebugUtils';
import { getFromLocalStorage } from '../utils/Util';

const ServicesManagerAPICall = {
  request: async (
    methodType: string,
    endpoint: string,
    data?: any,
    hasAuthToken: boolean = true,
    paramAsPathVariable?: any,
    customHeaders?: any,
  ) => {
    let queryParams: string = '';
    let url: any;
    let authenticationDatum: any;
    const authData: any = JSON.parse(getFromLocalStorage(STORAGE_KEY.AUTH_DATA));
    const userName = authData?.employeeName ? authData?.employeeName.split(':')[0] : ""

    if (hasAuthToken) {
      authenticationDatum = ''
      //TODO
      // (await getStorageDatum(Constants.AUTHENTICATION_DATUM)) ?? {};
    }

    let headers = hasAuthToken
      ? {
        Authorization: `Bearer ${authenticationDatum[0].token ?? ''}`,
        'Content-Type': 'application/json',
        'requester': `${userName}`
      }
      : {
        Authorization: `Basic ${paths.basicAuthString}`,
        'Content-Type': 'application/json',
        'requester': `${userName}`
      }
    
    if(customHeaders){
      headers = {...headers, ...customHeaders}
    }

    const config: AxiosRequestConfig = {
      method: '',
      url: '',
      headers: headers
    };

    try {
      switch (methodType) {
        case 'GET':
          {
            if (data) {
              const keys = Object.keys(data);
              if (paramAsPathVariable) {
                queryParams = '/';
                keys.forEach((key, index) => {
                  queryParams += `${data[key]}`;
                  if (index !== keys.length - 1) {
                    queryParams += '/';
                  }
                });
                url = `${paths.BASE_URL}${endpoint}${queryParams}`;
              }
              else {
                queryParams = Object.keys(data)?.length > 0 ? '?' : '';
                keys.forEach((key, index) => {
                  queryParams += `${key}=${data[key]}`;
                  if (index !== keys.length - 1) {
                    queryParams += '&';
                  }
                });
                url = `${paths.BASE_URL}${endpoint}${queryParams}`;
              }
            } else {
              url = `${paths.BASE_URL}${endpoint}`;
            }
            config.method = `${methodType.toLowerCase()}`;
            config.url = url;
          }
          break;

        case 'POST':
          {
            config.method = `${methodType.toLowerCase()}`;
            config.url = `${paths.BASE_URL}${endpoint}`;
            config.data = data;
          }
          break;
        case 'PUT':
          {
            if (data && typeof data === 'object' && data.queryParams) {
              // Handle query parameters for PUT request
              const queryData = data.queryParams;
              const bodyData = data.bodyData || {};
             
              if (Object.keys(queryData).length > 0) {
                queryParams = '?';
                for (const key in queryData) {
                  queryParams += `${key}=${queryData[key]}&`;
                }
                url = `${paths.BASE_URL}${endpoint}${queryParams}`;
              } else {
                url = `${paths.BASE_URL}${endpoint}`;
              }
              config.method = `${methodType.toLowerCase()}`;
              config.url = url;
              config.data = Object.keys(bodyData).length > 0 ? bodyData : undefined;
            } else {
              // Default PUT behavior - data goes to body
              config.method = `${methodType.toLowerCase()}`;
              config.url = `${paths.BASE_URL}${endpoint}`;
              config.data = data;
            }
          }
          break;
        case 'PATCH':
          {
            config.method = `${methodType.toLowerCase()}`;
            config.url = `${paths.BASE_URL}${endpoint}`;
            config.data = data;
          }
          break;

        case 'DELETE':
          {
            if (data) {
                queryParams = Object.keys(data)?.length > 0 ? '?' : '';
                for (const key in data) {
                  queryParams += `${key}=${data[key]}&`;
                }
                url = `${paths.BASE_URL}${endpoint}${queryParams}`;
            } else {
              url = `${paths.BASE_URL}${endpoint}`;
            }
            config.method = `${methodType.toLowerCase()}`;
            config.url = url;
          }
          break;
        case 'OPTIONS':
          {
            config.method = `${methodType.toLowerCase()}`;
            config.url = `${paths.BASE_URL}${endpoint}`;
          }
          break;

        default:
          throw new Error(`Unsupported method type: ${methodType}`);
      }

      DebugUtils.printState(`config : ${JSON.stringify(config)}`);
      const response = await axios(config);
      DebugUtils.printState(`status : ${JSON.stringify(response.status)}`);
      if (response.status === 200) {
        DebugUtils.successState(
          `responseData : ${JSON.stringify(response.data)}`,
        );
        return response.data ?? {};
      }
    } catch (error: any) {
      DebugUtils.errorState(`error : ${error}`);
      if (error.response) {
        // Handle the response error
        DebugUtils.errorState(`response error : ${JSON.stringify(error.response.data)}`);
        return error.response.data ?? {};
      } else {
        // Handle the generic error message
        DebugUtils.errorState(`message error : ${error.message}`);
        return { message: error.message };
      }
    }
    
  },
};

export default ServicesManagerAPICall;
